import "modern-normalize/modern-normalize.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-grid-layout/css/styles.css";
import "rc-menu/assets/index.css";

import { initNonAuthApp } from "@enfusion-ui/web-layout";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

initNonAuthApp(App, serviceWorker);
